// extracted by mini-css-extract-plugin
export default {"level":"styles_level__zhDQR","content":"styles_content__iUYNm"};